export default "/images/bc1dbd6549d26231eefd2e3f1ffdf6db.avif";